import { render, staticRenderFns } from "./BusinessAccounts.vue?vue&type=template&id=7875eaa4"
import script from "./BusinessAccounts.vue?vue&type=script&lang=js"
export * from "./BusinessAccounts.vue?vue&type=script&lang=js"
import style0 from "./BusinessAccounts.vue?vue&type=style&index=0&id=7875eaa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports